export default __webpack_public_path__ + "static/media/gitbook.53db4ac5.svg";